import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import session from '../plugins/session'
import { pick } from 'lodash'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  saveState (key, state) {
    if (session.exists()) {
      const keysToPersist = Object.keys(state)
      keysToPersist.forEach((k) => session.set(k, state[k]))
    }
  },
  restoreState () {
    if (session.exists()) {
      return session.getAll()
    }
  },
  reducer (state) {
    return pick(state, ['perfil', 'id_unidade_negocio'])
  }
})

const state = {
  breadcrumbs: [],
  perfil: {},
  id_unidade_negocio: null
}
const mutations = {
  setBreadcrumbs (state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs
  },
  setPerfil (state, perfil) {
    state.perfil = perfil
  },
  setUnidadeNegocio (state, id_unidade_negocio) {
    state.id_unidade_negocio = id_unidade_negocio
  }
}
const actions = {}
const plugins = [vuexLocal.plugin]

export default new Vuex.Store({
  state,
  mutations,
  actions,
  plugins
})
